import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import backend from 'utils/backend';
import storage from 'utils/storage';

const ClientData = (props) => {
  const user = props.user;
  const clientData = props.clientData;
  const clientDataSet = props.clientDataSet;

  React.useEffect(() => {
    const shouldForceReload = Boolean(clientData.reloadRequestId);

    const loadClientData = async () => {
      try {
        if (!shouldForceReload) {
          const storedData = await storage.clientData.get();
          if (storedData) {
            clientDataSet(storedData);
          }
        }
        const clientData = await backend.client.getClient(user.clientRn, true, true, true, true, true);
        clientDataSet({
          ...clientData,
          // Clear reload flag after servicing to resume normal cached loads.
          reloadRequestId: null,
        });
        await storage.clientData.set(clientData);
      } catch (e) {
        console.error('Failed to fetch user data', e);
      }
    };

    const shouldLoadForUserChange = user?.clientRn && clientData.clientRn !== user.clientRn;

    if (user?.clientRn && (shouldLoadForUserChange || shouldForceReload)) {
      loadClientData();
    }
  }, [user?.clientRn, clientData.reloadRequestId]);

  return null;
};

ClientData.propTypes = {
  user: PropTypes.object,
  clientData: PropTypes.object,
  clientDataSet: PropTypes.func,
};
const mapStateToProps = (state) => ({
  user: state.user,
  clientData: state.clientData,
});

export default connect(mapStateToProps, dispatch)(React.memo(ClientData));
